import _objectSpread from "@babel/runtime/helpers/objectSpread2";
// Allow providing a basic button, or a button tied to a reg modal!
import { FlowId } from '@nerdwallet/js-auth-tools/constants';
import nwApiSDKTools from '@nerdwallet/nw-api-sdk'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import get from 'lodash/get'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import omit from 'lodash/omit'; // eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration

import assign from 'lodash/assign';
var BASIC_NO_CAROUSEL = 'basic-no-carousel';
var IDENTITY_GOAL_TYPES = nwApiSDKTools.IDENTITY_GOAL_TYPES,
    IDENTITY_GOAL_SUBTYPES = nwApiSDKTools.IDENTITY_GOAL_SUBTYPES,
    IDENTITY_ONBOARDING_INTEREST_TYPES = nwApiSDKTools.IDENTITY_ONBOARDING_INTEREST_TYPES;
var savingsGoal = {
  goal_type: IDENTITY_GOAL_TYPES.SAVINGS_GOAL,
  goal_subtype: IDENTITY_GOAL_SUBTYPES.GENERIC
};
var debtGoal = {
  goal_type: IDENTITY_GOAL_TYPES.DEBT_GOAL
};
var retirementGoal = {
  goal_type: IDENTITY_GOAL_TYPES.RETIREMENT_GOAL
};
var creditGoal = {
  goal_type: IDENTITY_GOAL_TYPES.CREDIT_GOAL
};
var emergencyFundGoal = {
  goal_type: IDENTITY_GOAL_TYPES.SAVINGS_GOAL,
  goal_subtype: IDENTITY_GOAL_SUBTYPES.EMERGENCY_FUND
};

var openDialog = function openDialog(flow) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      createGoal = _ref.createGoal,
      skipGoalCreation = _ref.skipGoalCreation,
      onboardingProfile = _ref.onboardingProfile;

  return function () {
    var flowProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (typeof get(window, 'nwapi.ui.showAuthDialog') === 'function') {
      // basic-no-carousel not supported on v1
      var version = flow === BASIC_NO_CAROUSEL ? 1 : 2;
      var flowConfig = {};

      if (createGoal !== undefined) {
        flowConfig.createGoal = createGoal;
      }

      if (skipGoalCreation !== undefined) {
        flowConfig.skipGoalCreation = skipGoalCreation;
      }

      if (onboardingProfile !== undefined) {
        flowConfig.onboardingProfile = onboardingProfile;
      }

      if (flowProps.flowConfig) {
        assign(flowConfig, flowProps.flowConfig);
      }

      var flowOverrides = omit(flowProps, 'flowConfig');
      window.nwapi.ui.showAuthDialog(_objectSpread({
        version: version,
        flow: flow,
        flowConfig: flowConfig
      }, flowOverrides));
    }
  };
};

export default {
  basicNoCarousel: openDialog(BASIC_NO_CAROUSEL),
  // BASIC-NO-CAROUSEL flow is deprecated
  basic: openDialog(FlowId.ONBOARDING_GENERIC),
  // BASIC flow is deprecated
  cashBack: openDialog(FlowId.BASIC, {
    skipGoalCreation: true,
    onboardingProfile: {
      onboarding_interest: IDENTITY_ONBOARDING_INTEREST_TYPES.SAVE_MONEY
    }
  }),
  onboardingGeneric: openDialog(FlowId.ONBOARDING_GENERIC),
  connectAccounts: openDialog(FlowId.ACCOUNT_AGG),
  creditScore: openDialog(FlowId.CREDIT_SCORE),
  bills: openDialog(FlowId.BILLS_SETUP),
  basicNoGoal: openDialog(FlowId.BASIC, {
    skipGoalCreation: true
  }),
  emergencyFundGoal: openDialog(FlowId.BASIC, {
    createGoal: emergencyFundGoal
  }),
  savingsGoal: openDialog(FlowId.BASIC, {
    createGoal: savingsGoal
  }),
  retirementGoal: openDialog(FlowId.BASIC, {
    createGoal: retirementGoal
  }),
  debtGoal: openDialog(FlowId.BASIC, {
    createGoal: debtGoal
  }),
  creditGoal: openDialog(FlowId.BASIC, {
    createGoal: creditGoal
  })
};